import commonMessage from "../../constant/commonMessage";

const {
  SURVEY_TITLE_REQUIRED,
  SURVEY_CATEGORY_REQUIRED,
  EXPIRY_DATE_REQUIRED,
  SURVEY_DESCRIPTION_REQUIRED,
  SURVEY_DURATION_REQUIRED,
  SURVEY_BLOCK_TITLE_REQUIRED,
  PARTICIPANT_FEEDBACK_REASON
} = commonMessage;

export const survey = {
  //Create Survey Schema
  createSurveySchema: {
    title: {
      required: true,
      message: SURVEY_TITLE_REQUIRED,
    },
    surveyCategory: {
      required: true,
      message: SURVEY_CATEGORY_REQUIRED,
    },
    expiryDate: {
      required: true,
      message: EXPIRY_DATE_REQUIRED,
    },
    description: {
      required: true,
      message: SURVEY_DESCRIPTION_REQUIRED,
    },
    duration: {
      required: true,
      message: SURVEY_DURATION_REQUIRED,
    },
  },

  // Add new Block schema
  addNewSuveyBlockSchema: {
    blockName: {
      required: true,
      message: SURVEY_BLOCK_TITLE_REQUIRED,
    },
  },

  // Add new Block schema
  extendExpiryDateSchema: {
    expiryDate: {
      required: true,
      message: EXPIRY_DATE_REQUIRED,
    },
  },

    // Reject Selected Participant Feedback Status
    rejectParticipantSelectedFeedbackSchema: {
      reason: {
        required: true,
        message: PARTICIPANT_FEEDBACK_REASON,
      },
    },
};
